import apiConfig from '../../../../../../../config/api'
import { apiRequestorHelper } from '../../../../../../../helpers'

export const getMonitoringRulesService = () => {
    return apiRequestorHelper({
        url: apiConfig.url + '/transaction/inside/getMonitoringRulesSumary',
        method: 'post',
        body: {}
    })
}